/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // Mirrors theme.js singles() logic for sections with data-auto-height attribute.
  // Runs at DOM-ready (custom.js is defer, after theme.js) so CSS vars are already
  // set, giving sections the correct content-based min-height before first paint
  // rather than waiting for window.load.
  function earlyPreventOverflow() {
    document.querySelectorAll('[data-auto-height]').forEach(function(frame) {
      var wrappers = frame.querySelectorAll('.js-overflow-content');
      var tallest = 0;
      var padding = 64;
      wrappers.forEach(function(wrap) {
        if (wrap.offsetHeight > tallest) {
          var style = window.getComputedStyle(wrap);
          var margin = parseInt(style.marginTop) + parseInt(style.marginBottom);
          if (margin > padding) padding = margin;
          tallest = wrap.offsetHeight;
        }
      });
      if (tallest === 0) return;
      var backgrounds = frame.querySelectorAll('[data-overflow-background]');
      [frame].concat(Array.from(backgrounds)).forEach(function(el) {
        el.style.setProperty('min-height', 'calc(' + (tallest + padding) + 'px + var(--menu-height))');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', earlyPreventOverflow);
  } else {
    earlyPreventOverflow();
  }

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => {  });
  document.addEventListener('theme:scroll:up', e => {  });
  document.addEventListener('theme:scroll:down', e => {  });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => {  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  function initHomeSlideshow() {
    var $slider = document.querySelector('.slideshow__wrapper');
    if ($slider && !$slider.classList.contains('flickity-enabled')) {
      new Flickity($slider, {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        adaptiveHeight: false,
        prevNextButtons: true,
        pageDots: true,
        dragThreshold: 5
      });
    }
  }

  // Shopify sections re-render with Shopify's AJAX navigation
  document.addEventListener('shopify:section:load', function(e) {
    if (window.location.pathname === "/" || window.location.pathname === "/index") {
      setTimeout(initHomeSlideshow, 100);
    }
  });

  // Also on initial page load
  document.addEventListener('DOMContentLoaded', function() {
    if (window.location.pathname === "/" || window.location.pathname === "/index") {
      setTimeout(initHomeSlideshow, 100);
    }
  });

  var WRAP_VARIANT_ID = 45190045565084;
  var wrapRequest = Promise.resolve();

  // UpCart's toggle reads this global; seed it from the real cart so it survives page loads.
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      window.__upcartDoubleWrap = cart.items.some(function(item) { return item.variant_id === WRAP_VARIANT_ID; });
    })
    .catch(function() {});

  document.addEventListener('upcart:double-wrap', function(e) {
    var quantity = e.detail.selected ? 1 : 0;
    // /cart/update.js sets an absolute quantity, so a repeat fire cannot add a second wrap.
    wrapRequest = wrapRequest.then(function() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [WRAP_VARIANT_ID]: quantity } })
      });
    }).catch(function(err) { console.error('[double-wrap]', err); });
  });

  // Video banner: swap desktop/mobile video on breakpoint crossing
  var videoBannerListeners = {};

  function initVideoBanner(container) {
    var id = container.dataset.sectionId;
    var video = container.querySelector('.video-banner__video-wrapper video');
    if (!video) return;

    var desktopSrc = video.dataset.desktopSrc;
    var mobileSrc  = video.dataset.mobileSrc;
    if (!mobileSrc) return;

    var mq = window.matchMedia('(max-width: 749px)');

    var handler = function(e) {
      var targetSrc = e.matches ? mobileSrc : desktopSrc;
      if (video.currentSrc === targetSrc) return;
      video.src = targetSrc;
      video.load();
      var p = video.play();
      if (p) p.catch(function(err) { console.error('[video-banner] play() rejected:', err); });
    };
    videoBannerListeners[id] = { mq: mq, handler: handler };
    mq.addEventListener('change', handler);
  }

  function destroyVideoBanner(id) {
    var stored = videoBannerListeners[id];
    if (stored) {
      stored.mq.removeEventListener('change', stored.handler);
      delete videoBannerListeners[id];
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    var sections = document.querySelectorAll('[data-section-type="video-banner"]');
    sections.forEach(initVideoBanner);
  });

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.dataset.sectionType === 'video-banner') {
      initVideoBanner(e.target);
    }
  });

  document.addEventListener('shopify:section:unload', function(e) {
    if (e.target.dataset.sectionType === 'video-banner') {
      destroyVideoBanner(e.target.dataset.sectionId);
    }
  });

    document.addEventListener('DOMContentLoaded', function () {
    var viewingCount = document.getElementById('viewing-count');
    if (viewingCount) {
      // Generate a random number between 8 and 34 (or whatever range you want)
      var people = Math.floor(Math.random() * (34 - 8 + 1)) + 8;
      viewingCount.textContent = people;
    }
  });

  // --- Product page client-side variant selection ---
  //
  // Pipeline's changeVariant() calls $sectionApi.navigate() which fetches
  // /products/handle?variant=ID&section_id=... via window.fetch. Upcart patches
  // window.fetch and intercepts any /products/ URL, re-initializing itself and
  // corrupting its CSS/state. This manifests as a broken drawer on ATC after a
  // variant change.
  //
  // Fix: after Alpine initializes, replace changeVariant on the productForm()
  // component with a client-side version that updates variantId (bound to the
  // ATC form via x-model.fill), price display, and URL — no fetch, no section
  // re-render, no Upcart interference.
  //
  function isProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }

  function plFormatMoney(cents, format) {
    var str = (cents / 100).toFixed(2);
    var parts = str.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var oc = '{' + '{';
    var cc = '}' + '}';
    return (format || oc + 'amount' + cc)
      .replace(oc + 'amount_no_decimals_with_comma_separator' + cc, whole.replace(/,/g, '.'))
      .replace(oc + 'amount_no_decimals' + cc, whole)
      .replace(oc + 'amount_with_comma_separator' + cc, whole.replace(/,/g, '.') + ',' + parts[1])
      .replace(oc + 'amount' + cc, whole + '.' + parts[1]);
  }

  function installProductVariantOverride() {
    if (!isProductPage()) return;

    var section = document.querySelector('[data-section-type="product"]');
    if (!section) return;

    var variantsScript = section.querySelector('[data-pl-variants]');
    if (!variantsScript) return;

    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch(e) { return; }

    var variantMap = {};
    variants.forEach(function(v) { variantMap[v.id] = v; });

    var optionKeys = ['option1', 'option2', 'option3'];

    var productRoot = section.querySelector('[data-morph-children-only]');
    if (!productRoot) return;

    var alpineData = window.Alpine && window.Alpine.$data(productRoot);
    if (!alpineData || typeof alpineData.changeVariant !== 'function') return;
    if (alpineData._plVariantOverride) return;

    var priceEl = section.querySelector('[data-product-price]');
    var comparePriceEl = section.querySelector('[data-compare-price]');
    var buttonPriceEl = section.querySelector('[data-button-price]');
    var moneyFormat = (window.theme && window.theme.moneyFormat) || '{{amount}}';

    alpineData.changeVariant = function(variantUrl, newVariantId, variantMediaId) {
      if (newVariantId !== null && newVariantId !== undefined) {
        this.variantId = newVariantId;

        var variant = variantMap[newVariantId];
        if (variant) {
          if (priceEl) {
            priceEl.textContent = plFormatMoney(variant.price, moneyFormat);
            if (variant.compare_at_price > variant.price) {
              priceEl.classList.add('product__price--sale');
            } else {
              priceEl.classList.remove('product__price--sale');
            }
            if (comparePriceEl) {
              if (variant.compare_at_price > variant.price) {
                comparePriceEl.textContent = plFormatMoney(variant.compare_at_price, moneyFormat);
                comparePriceEl.style.display = '';
              } else {
                comparePriceEl.style.display = 'none';
              }
            }
          }
          if (buttonPriceEl) {
            buttonPriceEl.textContent = plFormatMoney(variant.price, moneyFormat);
          }

          section.querySelectorAll('[data-option-position]').forEach(function(wrapper) {
            var pos = parseInt(wrapper.getAttribute('data-option-position'), 10) - 1;
            if (pos < 0 || pos > 2) return;
            var optionVal = variant[optionKeys[pos]];
            var target = wrapper.querySelector('[data-swapper-target]');
            if (target && optionVal != null) target.textContent = optionVal;
            wrapper.querySelectorAll('input[name^="options"]:not([type="hidden"]), [data-popout-option]').forEach(function(el) {
              var val = el.value || el.getAttribute('data-value');
              if (!val) return;
              var found = variants.find(function(v) {
                return optionKeys.every(function(key, i) {
                  return i === pos ? v[key] === val : v[key] === variant[key];
                });
              });
              el.classList.remove('sold-out', 'unavailable');
              if (!found) {
                el.classList.add('unavailable');
              } else if (!found.available) {
                el.classList.add('sold-out');
              }
            });
          });
        }
      }

      if (variantUrl) {
        try {
          var url = new URL(variantUrl);
          window.history.replaceState(null, '', url.pathname + url.search);
        } catch(e) {}
      }

      this.updateProductImage(variantMediaId);
    };
    alpineData._plVariantOverride = true;
  }

  // alpine:initialized already fired before custom.js runs (theme.js calls
  // Alpine.start() synchronously then sets window.Alpine). Call directly.
  installProductVariantOverride();

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

})();
